export default "__VITE_ASSET__DGO6pz5P__"